import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MailingService } from 'src/app/services/mailing.service';
import Swal from 'sweetalert2'

@Component({
  selector: 'app-mailing',
  templateUrl: './mailing.component.html',
  styleUrls: ['./mailing.component.scss']
})
export class MailingComponent implements OnInit {
  nro_cuenta: any = localStorage.getItem('cuenta');
  nro_cli: any = localStorage.getItem('nro_cliente');
  nro_prov: any = localStorage.getItem('nro_proveedor');
  asunto: any = '';
  cuerpo: any = '';
  area: any = '';
  tel_ventas: any = '';
  tel_prove: any = '';

  
  constructor(private router: Router, public mailing: MailingService ) { 
    this.area = this.router.url.slice(-3);
  }
  
  ngOnInit():void{
   this.mailing.consulCliente(this.nro_cuenta)
   .then((data:any)=>{
    this.tel_ventas= data.tel_venta;
    this.tel_prove= data.tel_prove;
})
  }
  

  enviarMail(){
    if(this.area=='cli'){
      this.nro_prov='';
    } else if(this.area=='pro'){
      this.nro_cli='';
    }
    this.mailing.envMail(this.nro_cuenta,this.nro_cli,this.nro_prov,this.asunto,this.cuerpo,this.area)
    .then((data:any)=>{
      if(parseInt(data.error)){
        Swal.fire({
          title: 'Oops...',
          text: data.mensaje
        })
      } else {
        Swal.fire({
          title: 'Consulta Exitosa!',
          text: data.mensaje
        })
      this.asunto='';
      this.cuerpo='';  
      }
  })
  }
}
